import React, { FC } from "react";

import { IgButton } from "@intelligems/ig-theme";
import { OnboardingStateType } from "@intelligems/ig-types";
import { KeyboardArrowLeft } from "@mui/icons-material";
import { Grid } from "@mui/material";

import { OnboardingSteps } from "../../../../types/organization";

interface NavigateButtonProps {
  handleBack: () => void;
  steps: OnboardingSteps[];
  onboardingState: OnboardingStateType;
}

export const NavigateButtons: FC<NavigateButtonProps> = ({
  steps,
  handleBack,
  onboardingState,
}) => {
  return (
    <Grid container direction={"row"} justifyContent={"space-between"}>
      <Grid item>
        <IgButton
          sx={{
            fontSize: "16px",
            fontWeight: 400,
            letterSpacing: "0.15px",
          }}
          onClick={handleBack}
          disabled={onboardingState.activeStep === steps.length}
        >
          <KeyboardArrowLeft />
          Back
        </IgButton>
      </Grid>
    </Grid>
  );
};
